import PageScroll from "./PageScroll";

const ContentPageScroll = ({ icons, parentToolTip, scrollToView }) => {
  return <PageScroll icons={icons} parentToolTip={parentToolTip} scrollToView={scrollToView} />;
};
export default ContentPageScroll;
